/**
 * KAN-964: вкладка "Встречи" приложения менеджера (/m/meetings): встречи и звонки
 * выбранного дня (по умолчанию сегодня, просроченные по кнопке) и календарь месяца
 * под списком по кнопке. Тот же раздел, что на дашборде, в мобильной раскладке;
 * строка ведёт в карточку клиента приложения, крупная кнопка звонка.
 */
import { useNavigate } from 'react-router-dom';
import { TodayStepsSection } from '@/components/todaySteps/TodayStepsSection';
import { mobileClientPath } from '@/lib/mobileApp';

export function MobileMeetingsPage(): JSX.Element {
  const navigate = useNavigate();
  return (
    <section className="px-4 py-4" data-testid="mobile-meetings-page">
      <TodayStepsSection
        calendarLayout="collapsed"
        callSize="lg"
        onOpen={(item) => navigate(mobileClientPath(item.client_id))}
      />
    </section>
  );
}
